import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagGroupEditContainer from '../../containers/tag/TagGroupEditContainer';
import { tagActions } from '../../store/modules/tag';

class TagCreate extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 태그 데이터 초기화
   */
  initiate = (tagGroupId) => {
    const { getTagGroupDetail } = this.props;
    getTagGroupDetail({
      tagGroupId,
    });
  };

  render() {
    const { editTagGroup } = this.props;

    return (
      <PageTemplate pageName={TAG_PAGE_NAME.TAG_GROUP_EDIT}>
        <TagGroupEditContainer onSubmit={editTagGroup} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  getTagGroupDetail: tagActions.getTagGroupDetail,
  editTagGroup: tagActions.editTagGroup,
};

export default connect(null, mapDispatchToProps)(withRouter(TagCreate));
